import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ClientsService } from "../../services/clients.service";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { Client } from "../../models/client.model";
import { ToastService } from "src/app/shared/toasts/toast-service";
import { ActivatedRoute, Router } from "@angular/router";
import { EventService } from "../../../events/event.service";
import { FeiraModel } from "../../../events/model/event.model";
import { Subject, takeUntil } from "rxjs";
import { Location } from '@angular/common';
import Swal from "sweetalert2";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalAtualizarFeiraClienteComponent } from "../modal-atualizar-feira-cliente/modal-atualizar-feira-cliente.component";
import { FeiraClienteDto } from "../../dto/feira-cliente.dto";

@Component({
  selector: "app-client-form",
  templateUrl: "./client-form.component.html",
  styleUrl: "./client-form.component.scss",
})
export class ClientFormComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  @Input() id: string | null = null;
  breadCrumbItems: Array<{}> = [];
  clientForm!: FormGroup;
  loading: boolean = false;
  events: FeiraModel[] = [];
  activeId: number = 1;

  currentLength: number = 0;

  constructor(
    private route: Router,
    private clientsService: ClientsService,
    private fb: FormBuilder,
    private toastService: ToastService,
    private eventService: EventService,
    private location: Location,
    private router: ActivatedRoute,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.initForm();

    this.breadCrumbItems = [
      { label: "Call center" },
      { label: "Contatos", active: true },
    ];

    this.router.queryParamMap.subscribe(queryParams => {
      const extraParam = queryParams.get('extra');
      if (extraParam) {
        this.activeId = +extraParam;
      }
    });

    this.eventService
      .getEvents()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (events) => {
          this.events = events;
        },
        error: (error) => {
          console.error("Erro ao buscar feiras:", error);
        },
      });
    if (this.id) {
      this.clientsService.getClientById(this.id).subscribe({
        next: (client) => {
          const { feiras, ...clientData } = client;
          this.clientForm.patchValue(clientData);
          feiras.forEach(({ id, nome, feiraId, metroQuadrado }) => {
            this.feiras.push(
              this.fb.group({
                nome: [{ value: nome, disabled: true }],
                id: [{ value: id, disabled: true }],
                feiraId: [{ value: feiraId, disabled: true }],
                metroQuadrado: [{ value: metroQuadrado, disabled: true }],
              }),
            );
          });
        },
        error: (error) => {
          console.error("Erro ao buscar cliente:", error);
        },
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initForm(): void {
    this.clientForm = this.fb.group({
      id: [""],
      nome: ["", [Validators.required]],
      email: ["", [Validators.email]],
      telefone: [""],
      ramal: [""],
      celular: [""],
      ramalCelular: [""],
      contato: [""],
      emailContato: ["", [Validators.email]],
      cnpj: ["", [Validators.minLength(14), this.cnpjValidator()]],
      inscricaoEstadual: [""],
      anotacao: [""],
      endereco: this.fb.group({
        cep: [""],
        rua: [""],
        numero: [""],
        complemento: [""],
        bairro: [""],
        cidade: [""],
        estado: [""],
      }),
      feiras: this.fb.array<FeiraModel[]>([], this.feiraM2Validator()),
      selectedFeira: this.fb.control(null),
      selectedM2: [""],
    });
  }

  get feiras(): FormArray {
    // console.log(this.clientForm.get("feiras"));
    return this.clientForm.get("feiras") as FormArray;
  }

  addFeira(): void {
    const feira = this.clientForm.get("selectedFeira")?.value as Pick<
      FeiraModel,
      "nome" | "id"
    >;
    //console.log('direto do select. Aqui tem que ser id. representa o feriaId correto', feira);
    const metroQuadrado = this.clientForm.get("selectedM2")?.value;

    if (!feira || !metroQuadrado) {
      return;
    }
    const feiras = this.clientForm.get("feiras") as FormArray;

    if (feiras.value.find((f: any) => f.feiraId === feira.id)) {
      this.toastService.show("Feira já adicionada!", {
        classname: "bg-warning text-light",
      });
      return;
    }

    feiras.push(
      this.fb.group({
        nome: [{ value: feira.nome, disabled: true }],
        metroQuadrado: [{ value: metroQuadrado, disabled: true }],
        id: [{ value: feira.id, disabled: true }],
        feiraId: [{ value: null, disabled: true }],
      }),
    );
    this.clientForm.get("selectedFeira")?.reset();
    this.clientForm.get("selectedM2")?.reset();
  }

  removeFeira(index: number): void {
    const feiras = this.clientForm.get("feiras") as FormArray;
    feiras.removeAt(index);
  }

  onSubmit(): void {

    let listaDeFeiras = this.clientForm.get("feiras")?.value;
    if (listaDeFeiras.length > 0) {
      this.clientForm.get('feiras')?.setErrors(null); // Limpa os erros do FormArray antes de validar
    }

    if (this.clientForm.invalid) {
      this.clientForm.markAllAsTouched();
      // Iterar sobre os campos e exibir os erros
      Object.keys(this.clientForm.controls).forEach((field) => {
        const control = this.clientForm.get(field);
        if (control?.errors) {
         
        }
      });
      return;
    }

    const { selectedFeira, selectedM2, ...data } = this.clientForm
      .value as Client & { selectedFeira: string; selectedM2: string };
    data.feiras = this.clientForm.get("feiras")?.value.map((f: any) => {
    
      const id = f?.feiraId == null ? null : f?.id;
      const feiraId = f?.feiraId == null ? f?.id : f?.feiraId;
      return {
        id,
        metroQuadrado: f.metroQuadrado,
        feiraId: feiraId
      };
    });

    //console.log("Form data:", this.clientForm?.value["feiras"]);
    this.loading = true;
    if (this.id) {

      this.clientsService.editClient(data).subscribe({
        next: () => {
          this.toastService.show("Cliente atualizado com sucesso!", {
            classname: "bg-success text-light",
          });
          
           setTimeout(() => {
            window.location.reload();
          }, 1500);

        },
        error: (error) => {
          this.loading = false
          this.toastService.show("Erro ao atualizar cliente!", {
            classname: "bg-danger text-light",
          });
        },
        complete: () => {
          this.loading = false;
        },
      });
    } else {
      const { id, ...rest } = data;

      this.clientsService.createClient(rest).subscribe({
        next: () => {
          this.toastService.show("Cliente criado com sucesso!", {
            classname: "bg-success text-light",
          });

          this.route.navigate(["/telemarketing/clientes/" + data.id]);
        },
        error: (error) => {
          this.toastService.show("Erro ao criar cliente!", {
            classname: "bg-danger text-light",
          });
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        },
      });
    }
  }

  // Validador customizado para o campo CNPJ
  cnpjValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      if (control.value && control.value.length !== 14) {
        return { invalidCnpjLength: true };
      }
      return null; // Sem erro
    };
  }

  // Validação customizada para o FormArray
  feiraM2Validator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const feirasArray = control as FormArray;

      // Verifica se pelo menos um item possui valores preenchidos para 'feira' e 'm2'
      const valid = feirasArray.controls.some((feiraControl) => {
        const feira = feiraControl.get('nome')?.value; // Campo 'nome' da feira
        const m2 = feiraControl.get('metroQuadrado')?.value; // Campo 'metroQuadrado'
        return feira && m2; // Se ambos os campos estiverem preenchidos, retorna true
      });

      return valid ? null : { feiraM2Required: true }; // Se não encontrar um par 'feira' + 'm2', retorna o erro
    };
  }

  voltar() {
    this.location.back();
  }

  /// Modal de deletar contato
  /// @param id - ID do contato a ser deletado (opcional)
  modalDeletarContato(id?: string) {
    this.excluirContato(id);
  }


  /// Responsável por abrir o modal de exclusão de contato
  /// @param id - ID do contato a ser excluído (opcional)
  private excluirContato(clienteId?: string) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger ms-2'
      },
      buttonsStyling: false
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Continuar Excluindo?',
        text: 'Você não poderá reverter isso! Todos os documentos e projetos pertencentes serão excluídos junto.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir',
        cancelButtonText: 'Não, cancelar!'
      })
      .then(result => {
        if (result.value) {
          swalWithBootstrapButtons.fire(
            'Excluído!',
            'Seu item foi excluído.',
            'success'
          );

          this.excluirCliente(clienteId);

          this.route.navigate(["/telemarketing/clientes"]);

        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelado',
            'Seu item continua seguro :)',
            'error'
          );
        }
      });
  }

  private excluirCliente(clienteId?: string) {
    this.clientsService.excluirCliente(clienteId!).subscribe({
      next: (response) => {
        this.toastService.show("Cliente excluído com sucesso!", {
          classname: "bg-success text-light",
        });
        this.route.navigate(["/telemarketing/clientes"]);
      },
      error: (error) => {
        this.toastService.show("Erro ao excluir cliente!", {
          classname: "bg-danger text-light",
        });
      },
    });
  }

  // RESPONSÁVEL PELA MODAL DE EDITAR FEIRA CLIENTE
  abrirModalEditarFeiraCliente(index: number) {

    const feiras = this.clientForm.get("feiras") as FormArray;
    let feiraSelecionada = feiras.at(index).value;

    const dto: FeiraClienteDto = {
      id: feiraSelecionada.id,
      nome: feiraSelecionada.nome,
      metros: feiraSelecionada.metroQuadrado,
      clienteId: this.clientForm.get('id')?.value,
      feiraId: feiraSelecionada.feiraId,
    };

    const modalRef = this.modalService.open(ModalAtualizarFeiraClienteComponent);
    modalRef.componentInstance.feiraClienteDto = dto;
  }

  // Contador de caracteres
  onInput(): void {
    this.currentLength = this.clientForm.get('anotacao')?.value.length || 0;
  }
}